export const AppRoutes = {
  HOME: "/",
  SIGNUP: "/sign-up",
  ADMIN_STATS:"/stats",
  ADMIN_USERS:"/users",
  CATEGORY:'/category',
  DELETE_USERS:"/users/delete/:id",
  DELETE_SUBADMIN:"/subadmin/delete/:id",
  TASKS:'/tasks',
  ADMINS:'/admins',
  ADD_ADMIN:'/admins/add-admin',
  QUESTIONS:'/all-questions',
  DASHBOARD:'/dashboard',
  DASHBOARD_CAT:'/dashboard/:category',
  NEWUSER:'/newuser',
  FORGET_PASSWORD:'/forget-password',
  PATIENT_DETAILS:'/patient-details',
  PATIENT_INFO:'/patient-info/:id',
  USERS:'/users',
  DOCTORS:'/doctors',
  SAMPLE:'/sample',
  INVOICE: '/invoice/:patientId/:claimId',
  APPOINTMENTPDF: '/apt-letter/:patientId/:claimId',
  INSURANCE_COMPANIES:'/insurance-companies',
  COMPANIES_ADJUSTERS:'/insurance/:id',
  OPEN_ACCESS_PATIENT_FORM:'/open-access-patient',
  NEW_ENTRIES:'/new-entries',
  NEW_ENTRIES_DETAILS:'/new-entry/details/:id',
  USER_PROFILE:'/profile',
  HOSPITAL:'/hospital', 
  SERVICES:'/services',
  PHYSICIAN:'/physician',
  AVAILABILITY:'/availability',
};